const DEFAULT_CONFIG = {
  allDaySlot: false,
  contextMenu: {
    items: [],
    render: null,
    onEvents: true,
    onCells: false,
  },
  calendarContainerClass: '',
  dayHeaderAlign: 'center',
  dayMinWidth: 150,
  editable: true,
  events: [],
  eventResizableFromStart: true,
  eventEditor: {
    render: null,
  },
  firstDay: 1,
  header: {
    left: undefined,
    center: undefined,
    right: undefined,
  },
  height: '100%',
  initialView: 'timeGridScrollWeek',
  isBroadcastClock: false,
  isLoading: false,
  scrollTime: '06:00:00',
  scrollTimeReset: false,
  selectable: true,
  slotDuration: '00:30:00',
  slotHeaderInterval: '01:00:00',
  slotEventOverlap: false,
  slotHeaderFormat: {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    omitZeroMinute: false,
    meridiem: 'uppercase',
  },
  slotMinHeight: 60,
  slotMinWidth: 60,
  timeZone: 'UTC',
  tooltip: 'on',
  views: {},
};

export default DEFAULT_CONFIG;
